import { useState } from "react";
import "./App.css";
import pageList from "../helpers/pageList";
import Calculator from "./calculators/calculator";
import ApplyForms from "./forms/applyForms";
import CalculatorList from "../helpers/calculatorList";

const App = () => {
  const [selectedPage, setSelectedPage] = useState(pageList.calculator);
  const [selectedCalc, setSelectedCalc] = useState(
    CalculatorList.refinance
  );

  return (
    <>
      {selectedPage === pageList.calculator && (
        <Calculator selectedCalc={selectedCalc} />
      )}
      {selectedPage === pageList.applyForms && <ApplyForms />}
    </>
  );
};

export default App;
